<div class="wrapper">
  <div class="parent">
    <div class="left">
      <div class="title">
        <h3>{{project?.Name.toUpperCase()}}</h3>
      </div>
      <div class="participants-list">
        <div>
          <svg-icon src='./assets/icons/people-outline.svg'
                    title="{{'raci.participantsAssignment.participants' | translate | uppercase}}"
                    class="menu-action-icon svg-icon-red"
                    align='center'>
          </svg-icon>
          <h4 class="participants-list-title">
            {{'raci.participantsAssignment.participantRoles' | translate | uppercase}}
          </h4>
        </div>
        <div class="participants-list-body-left">
          <div *ngFor="let role of projectRoles">
            <h4 class="participants-list-role-name" *ngIf="role.description !== ''" (click)="filterByRole($event, role)">
              {{role?.description.toUpperCase()}}
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="participants-description">
        <p>{{ 'raci.participantsAssignment.participantsDescription' | translate }}</p>
        <p>{{ 'raci.participantsAssignment.addNewParticipants' | translate }}</p>
        <p>{{ 'raci.participantsAssignment.changeRole' | translate }}</p>
        <p>{{ 'raci.participantsAssignment.changeView' | translate }}</p>
      </div>
      <div class="participants-view">
        <div>
          <svg-icon src='./assets/icons/people-outline.svg'
                    title="{{'raci.participantsAssignment.participants' | translate | uppercase}}"
                    class="menu-action-icon svg-icon-red"
                    align='center'>
          </svg-icon>
          <h4 *ngIf="!showExternalGrid" class="participants-list-title">
            {{'raci.participantsAssignment.participants' | translate | uppercase}}
          </h4>
          <h4 *ngIf="showExternalGrid" class="participants-list-title">
            {{'raci.participantsAssignment.externalParticipants' | translate | uppercase}}
          </h4>
        </div>
        <div class="participants-list-body">
          <div>
            <h4 class="participants-list-role-name">
              {{'raci.participantsAssignment.projectRolls' | translate | uppercase}}
            </h4>
          </div>
          <div *ngIf="participants && !showExternalGrid">
            <kendo-grid [data]="filteredParticipants"
                        #participantsGrid
                        id="participants"
                        class="kendo-white-grid custom-participants-grid"
                        [selectable]="selectableSettings"
                        (drop)="onDrop($event, participantsGrid)"
                        (dragover)="onDragOver($event, participantsGrid)"
                        (dragstart)="onDragStart($event, participantsGrid)">
              <kendo-grid-column [headerClass]="'participants-grid'" field="projectRole" title="{{'raci.participantsAssignment.roleTitle' | translate}}" [width]="40">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <kendo-dropdownlist [data]="filteredRoles" style="width:100%;" class="widget-input-text"
                                      textField="description"
                                      valueField="oid"
                                      *ngIf="!dataItem.isExternal"
                                      [valuePrimitive]="true"
                                      [(ngModel)]="dataItem.projectRoleId">
                  </kendo-dropdownlist>
                  <p class="hidden-text"
                     *ngIf="dataItem.isExternal">
                    {{dataItem.projectRole}}
                    <span class="tooltip">{{dataItem.projectRole}}</span>
                  </p>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'" field="name" title="{{'raci.participantsAssignment.nameTitle' | translate}}" [width]="40"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'" field="region" title="{{'raci.participantsAssignment.regionTitle' | translate}}" [width]="40"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'" field="sector" title="{{'raci.participantsAssignment.sectorTitle' | translate}}" [width]="40"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'" field="organizationalRole" title="{{'raci.participantsAssignment.organizationalRoleTitle' | translate}}" [width]="40"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'" field="email" title="{{'raci.participantsAssignment.emailTitle' | translate}}" [width]="40"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid text-center'" field="remove" title="" [width]="20" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <svg-icon  src='./assets/icons/close-outline.svg' class="menu-action-icon remove-participant-icon"
                            title="{{'projectToolbar.removeParticipantFromList' | translate | uppercase}}" align='center' (click)="removeRow(dataItem, participantsGrid)"></svg-icon>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
          <div *ngIf="showExternalGrid">
            <kendo-grid [data]="filteredParticipants"
                        #participantsGrid
                        id="participants"
                        class="kendo-white-grid external-user-grid"
                        [selectable]="selectableSettings"
                        (drop)="onDrop($event, participantsGrid)"
                        (dragover)="onDragOver($event, participantsGrid)"
                        (dragstart)="onDragStart($event, participantsGrid)"
                        (add)="addExternalUser($event)"
                        (save)="saveExternalUser($event)">
              <ng-template kendoGridToolbarTemplate>
                <button kendoGridAddCommand>Add new external user</button>
              </ng-template>
              <kendo-grid-column [headerClass]="'participants-grid'" field="projectRole" title="Role" [editable]="false" [width]="40">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span>{{getExternalRole().description}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'" field="name" title="Name" [width]="40"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid'" field="email" title="Email" [width]="40"></kendo-grid-column>
              <kendo-grid-column [headerClass]="'participants-grid text-center'" field="remove" title="" [width]="20" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <button kendoGridSaveCommand>
                    Save
                  </button>
                  <div class="action-icon">
                    <svg-icon src='./assets/icons/close-outline.svg' class="menu-action-icon svg-icon-gray" title="{{'projectToolbar.removeParticipantFromList' | translate | uppercase}}" align='center'></svg-icon>
                    <div class="icon-label-single-line" [innerHTML]="'projectToolbar.removeParticipantFromList' | translate | uppercase"></div>
                  </div>
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
    <div class="right participants-pane">
      <div>
        <h4 class="participants-user-title">
          {{'raci.participantsAssignment.user' | translate | uppercase}}
        </h4>
      </div>
      <div class="participants-search">
        <svg-icon src='./assets/icons/search-outline.svg' class="menu-action-icon svg-icon-gray"
                  title="{{'projectToolbar.search' | translate | uppercase}}"
                  align='center'></svg-icon>
        <input class="participants-user-search"
               [(ngModel)]="searchTerm"
               (keyup)="searchUsers()"
               type="text"
               placeholder="Type the name of the user" />
      </div>
      <div *ngIf="showNoRecordsInfoMessage">
        <h4>{{'raci.participantsAssignment.noRecordsInfoMessage' | translate}}</h4>
      </div>
      <div *ngIf="!showNoRecordsInfoMessage">
        <div class="title-section">
          <h4 class="participants-title">
            {{'raci.participantsAssignment.otherUsers' | translate }}
          </h4>
          <svg-icon src='./assets/icons/chevron-down-outline.svg'
                    [ngClass]="otherUsersSectionCollapsed ? 'icon-toogle-rotate' : 'icon-toogle' "
                    title="OTHER USERS"
                    (click)="expandSection($event, 'other')">
          </svg-icon>
        </div>
        <div *ngIf="otherUsersSectionCollapsed" class="other-user-list">
          <kendo-grid class="kendo-white-grid"
                      [data]="filteredUsers"
                      #usersGrid
                      id="users"
                      (drop)="onDrop($event,usersGrid)"
                      (dragover)="onDragOver($event, usersGrid)"
                      (dragstart)="onDragStart($event, usersGrid)"
                      [hideHeader]="true">
            <kendo-grid-column [headerClass]="'participants-grid'" field="User_Description" title="" [width]="40"></kendo-grid-column>
          </kendo-grid>
        </div>
        <div class="directors-section">
          <div class="title-section">
            <h4 class="participants-title">
              {{'raci.participantsAssignment.directors' | translate | uppercase}}
            </h4>
            <svg-icon src='./assets/icons/chevron-down-outline.svg'
                      [ngClass]="directorsSectionCollapsed ? 'icon-toogle-rotate' : 'icon-toogle' "
                      title="DIRECTORS"
                      (click)="expandSection($event, 'directors')">
            </svg-icon>
          </div>
          <div *ngIf="directorsSectionCollapsed" class="participants-directors-list">
            <kendo-grid class="kendo-white-grid"
                        [data]="directors"
                        #directorsGrid
                        id="directors"
                        (drop)="onDrop($event, directorsGrid)"
                        (dragover)="onDragOver($event, directorsGrid)"
                        (dragstart)="onDragStart($event, directorsGrid)"
                        [hideHeader]="true">
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="User_Description"
                                 title=""
                                 [width]="40"></kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
        <div class="external-users-section">
          <div class="title-section">
            <h4 class="participants-title">
              {{'raci.participantsAssignment.externalUsers' | translate | uppercase}}
            </h4>
            <svg-icon src='./assets/icons/chevron-down-outline.svg'
                      [ngClass]="externalSectionCollapsed ? 'icon-toogle-rotate' : 'icon-toogle' "
                      title="EXTERNAL USERS"
                      (click)="expandSection($event, 'external')">
            </svg-icon>
          </div>
          <div *ngIf="externalSectionCollapsed" class="participants-directors-list">
            <kendo-grid class="kendo-white-grid"
                        [data]="externalUsers"
                        #externalUsersGrid
                        id="externalUsers"
                        (drop)="onDrop($event, externalUsersGrid)"
                        (dragover)="onDragOver($event, externalUsersGrid)"
                        (dragstart)="onDragStart($event, externalUsersGrid)"
                        [hideHeader]="true">
              <kendo-grid-column [headerClass]="'participants-grid'"
                                 field="User_Description"
                                 title=""
                                 [width]="40"></kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
